export const safeParse = (val) => {
  if (!val || val === "undefined" || val === "null") return null;
  try {
    return JSON.parse(val);
  } catch {
    return null;
  }
};

export const formatValue = (value) => {
  if (value === null || value === undefined || value === "" || value === "null") {
    return "--";
  }

  if (Array.isArray(value)) {
    return value.length ? value.join(", ") : "--";
  }

  if (typeof value === "object") {
    return JSON.stringify(value);
  }

  return String(value);
};

export const hexToRgba = (hex, opacity) => {
  let r = 0,
    g = 0,
    b = 0;
  // Handle #abc
  if (hex.length === 4) {
    r = parseInt(hex[1] + hex[1], 16);
    g = parseInt(hex[2] + hex[2], 16);
    b = parseInt(hex[3] + hex[3], 16);
  }
  // Handle #abcdef
  else if (hex.length === 7) {
    r = parseInt(hex.substring(1, 3), 16);
    g = parseInt(hex.substring(3, 5), 16);
    b = parseInt(hex.substring(5, 7), 16);
  }
  return `rgba(${r}, ${g}, ${b}, ${opacity})`;
};

export { sanitizeHtml } from "../components/common/SanitizeHtml";
